module.exports = __webpack_public_path__ + "img/roman.a463c6b6.png";